var _a;
// Marks a floating layer as the host that nested poppers should portal into
// instead of document.body.
//
// A popper rendered inline is clipped by the scroll container such a layer uses
// (StyledDropdownMenuWrapper is overflow-x: auto with a max-height), which is why
// it has to be portaled at all. But a popper portaled to document.body leaves the
// layer's DOM subtree, and the layer dismisses on outside clicks detected with
// Node.contains() — react-popper-tooltip, for the dropdown — so every click inside
// the popper reads as a click outside the layer and tears it down.
var FLOATING_HOST_ATTRIBUTE = "data-floating-host";
export var FLOATING_HOST_ATTRIBUTES = (_a = {}, _a[FLOATING_HOST_ATTRIBUTE] = "", _a);
export var FLOATING_HOST_SELECTOR = "[".concat(FLOATING_HOST_ATTRIBUTE, "]");
